export default "__VITE_ASSET__BpYI0hIn__"